import _ from 'lodash';

/*---------------------------------------------------------*\
 * OtherRegionsController
\*---------------------------------------------------------*/
class OtherRegionsController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor(localService, navigationService, storageKeys) {
    this.name = 'otherRegions';

    this.title = this.title || 'Select a region:';

    // setting an optional currentRegion property will give flexibility when switching regions on the fly.
    const region = _.isUndefined(this.currentRegion) ?
      localService.get(storageKeys.selectedRegion) :
      this.currentRegion;
    const regions = [].concat(localService.get(storageKeys.regions));
    this.regions = regions.filter((r) => { return r.abbr !== region.abbr; });
    navigationService.focusElAsync('.main-content');
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  selectRegion(region) {
    this.onSelect({ region });
  }

  onRegionKeyDown(event, region, index) {
    this.onKeydown({
      event,
      region,
      index
    });
  }
}

OtherRegionsController.$inject = ['localService', 'navigationService', 'storageKeys'];

export default OtherRegionsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/otherRegions/otherRegions.controller.js
 **/